import script from "./DetailListNota.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailListNota.vue?vue&type=script&setup=true&lang=js"

import "./DetailListNota.vue?vue&type=style&index=0&id=76a409b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a409b8"]])

export default __exports__